import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"mt-2 mb-2 pa-0",attrs:{"dark":"","color":"#17A2B8"}},[_c(VCardText,{staticClass:"pa-2 pl-3"},[_c('h4',{staticStyle:{"color":"#fff"}},[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }